import React from 'react'
import './Hero.css';

function Hero() {
  return (
    <div className='hero'>
        <div className='hero-left'>
            <h2>Your Health,<strong> Our Priority</strong></h2>
            <p>Welcome to Fatima Hospital and Diagnostic Centre, where your health and well-being are our top priority. We are committed to providing exceptional medical care and diagnostic services to ensure you receive the best possible treatment.</p>
            <button>Book Appointment</button>
        </div>

        <div className='hero-right'>
            <img src='https://res.cloudinary.com/dxnukbo0u/image/upload/v1721659885/21199_hxyahl.jpg' alt='doctors'></img>
        </div>
    </div>
  )
}

export default Hero